import { TrustAPI } from "@/shared/modules/trust-api";
import { Inject, Options, Prop, Vue } from "vue-property-decorator";
import { AuditTrailView } from '@/shared/modules/typescript-trustapi-client/models';
import AuditTrailModal from '../../audit-trail-modal/index.vue';
import { AppInsights } from "@/trust-admin-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import { orderBy } from "lodash";

@Options({
  components: {
    AuditTrailModal
  }
})
export default class AuditTrail extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop()
  private investigationName! : string;
  
  @Prop()
  private investigationId!: number;
  
  private loadingContent = false;
  private errorLoadingContent = false;

  private auditTrail: AuditTrailView[] = [];

  created(): void {
    this.loadAuditTrail(this.investigationId);
  }

  private closeModal(): void {
    this.$emit('closeAuditTrailModal');
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private async loadAuditTrail(inspectionId: number): Promise<void> {
    try {
      this.errorLoadingContent = false;
      this.loadingContent = true;
      const resp: any =
        await this.apiService.ConfigTrustApi?.apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet(inspectionId)
        this.auditTrail = resp.data.data as AuditTrailView[];
        this.auditTrail = orderBy(
          this.auditTrail,
          ['date'],
          ['desc']
        );
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', err);
      this.ai.trackException('Error getting investigation type audit trail: ' + err);
    } finally {
      this.loadingContent = false;
    }
  }

}

